import { RiFocus2Line, RiGroupFill, RiHome2Fill, RiLineChartFill } from 'react-icons/ri';
import { PATH_APP } from 'src/routes/paths';
import { ReactNode } from 'react';

export type NavbarConfig = {
  id: number;
  title: string;
  href: string;
  icon?: ReactNode;
};

// メンバーメニューのメインメニュー
export const mainNavbarConfig: NavbarConfig[] = [
  {
    id: 1,
    title: 'ホーム',
    href: PATH_APP.me.root,
    icon: <RiHome2Fill size={18} />,
  },
  {
    id: 2,
    title: '1on1',
    href: PATH_APP.me.oneOnOnes.root,
    icon: <RiGroupFill size={18} />,
  },
  {
    id: 3,
    title: '目標',
    href: PATH_APP.me.goals,
    icon: <RiFocus2Line size={18} />,
  },
  {
    id: 4,
    title: '評価',
    href: PATH_APP.me.reviews.root,
    icon: <RiLineChartFill size={18} />,
  },
];

// メンバーメニューのサブメニュー
export const subNavbarConfig: NavbarConfig[] = [
  {
    id: 1,
    title: 'トップ',
    href: PATH_APP.organization.root,
  },
  {
    id: 2,
    title: 'メンバー',
    href: PATH_APP.organization.members.root,
  },
  {
    id: 3,
    title: '部門',
    href: PATH_APP.organization.teams.root,
  },
  {
    id: 4,
    title: '1on1履歴',
    href: PATH_APP.organization.oneOnOnes,
  },
  {
    id: 5,
    title: 'マネジメント\nレポート',
    href: PATH_APP.organization.managementReport,
  },
];

// 管理者メニューの組織設定
export const organizationConfig: NavbarConfig[] = [
  {
    id: 1,
    title: '組織情報',
    href: PATH_APP.admin.setting.root,
  },
  {
    id: 2,
    title: 'ユーザー管理',
    href: PATH_APP.admin.setting.users.root,
  },
  {
    id: 3,
    title: '部門管理',
    href: PATH_APP.admin.setting.teams.root,
  },
  {
    id: 4,
    title: '組織アジェンダ',
    href: PATH_APP.admin.setting.organizationAgenda,
  },
  {
    id: 5,
    title: 'メール通知設定',
    href: PATH_APP.admin.setting.notification,
  },
];

// 管理者メニューの評価
const reviewConfig: NavbarConfig[] = [
  {
    id: 1,
    title: '評価',
    href: PATH_APP.admin.reviewSetting.reviewList,
  },
  {
    id: 2,
    title: '全体評価履歴',
    href: PATH_APP.admin.reviewSetting.reviewSheets.root,
  },
  {
    id: 3,
    title: '評価テンプレート',
    href: PATH_APP.admin.reviewSetting.reviewTemplate,
  },
  {
    id: 4,
    title: 'カスタム評価項目',
    href: PATH_APP.admin.reviewSetting.customReview,
  },
  {
    id: 5,
    title: '等級表',
    href: PATH_APP.admin.reviewSetting.gradeMatrix.root,
  },
];

// 管理者メニューの1on1
const oneOnOneConfig: NavbarConfig[] = [
  {
    id: 1,
    title: '全体1on1履歴',
    href: PATH_APP.admin.oneOnOnes,
  },
  {
    id: 2,
    title: '1on1分析',
    href: PATH_APP.admin.setting.analytics.meeting.root,
  },
];
// 管理者メニューのスキルマップ
const skillMapConfig: NavbarConfig[] = [
  {
    id: 1,
    title: 'スキルマップ',
    href: PATH_APP.admin.skillMap.root,
  },
];

export interface FeatureConfig {
  id: number;
  title: string;
  configs: NavbarConfig[];
}
// 管理者メニューの機能設定
export const featureConfig: FeatureConfig[] = [
  { id: 1, title: '評価', configs: reviewConfig },
  { id: 2, title: '1on1', configs: oneOnOneConfig },
  { id: 3, title: 'スキルマップ', configs: skillMapConfig },
];
